import Vue from "vue";
import VueRouter from "vue-router";
import { pcRouter } from "./pcRoutes";
import { mobileRouter } from './mobileRoutes'
import { Message } from "element-ui";
import store from "@/store";

Vue.use(VueRouter);

// 检测设备类型的函数
// function isMobile() {
//   return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
// }

let routes;
// if (isMobile()) {
//   // 若为手机端，加载手机端路由配置
//   routes = mobileRouter
// } else {
//   // 若为 PC 端，加载 PC 端路由配置
//   routes = pcRouter
// }

function checkDeviceType() {
  const width = window.innerWidth;
  if (width <= 768) {
    return 'mobile';
  } else if (width <= 1024) {
    return 'tablet';
  } else {
    return 'pc';
  }
}

if (checkDeviceType() === 'mobile') {
  routes = mobileRouter
} else if (checkDeviceType() === 'tablet') {
  routes = mobileRouter
} else {
  routes = pcRouter
}


const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
  const language = to.meta?.language;
  
  if (language === 'ch') {
    localStorage.setItem('language', 1);
  } else if (language === 'en') {
    localStorage.setItem('language', 2);
  }
  
  const token = localStorage.getItem('token');
  // 需要登录的页面（包括PC和移动端的中英文版本）
  const publicPages = [
    '/personalCenter', 
    '/en/personalCenter', 
    '/personalCenter', 
    '/en/personalCenter'
  ];

  // if (to.path === '/') {
  //   next('/');
  // } else 
  if (!token && publicPages.includes(to.path)) {
    // 根据当前路由判断是PC端还是移动端，中文还是英文
    const isMobileRoute = to.path.includes('mobile');
    const isChinese = !to.path.startsWith('/en');
    console.log(isChinese, 'isChinese');
    
    // 设置对应的提示信息和登录页面路径
    const message = isChinese ? '请先登录' : 'Please log in first';
    const loginPath = isMobileRoute 
      ? (isChinese ? '/login' : '/en/login')
      : (isChinese ? '/login' : '/en/login');
  
    Message.error(message);
    setTimeout(() => {
      next(loginPath);
    }, 1000);
  } else {
    next();
  }
});

export default router;